export const bikeBrands = [
  // Last value added 335 : YAMAHA
  // 312 (doublon Merida)
  {
    "value": 999,
    "label": "bike:bike_types.other_brand"
  },
  {
    "value": 251,
    "label": "3T"
  },
  {
    "value": 1,
    "label": "Addbike"
  },
  {
      "value": 315,
      "label": "Aevon Bikes"
  },
  {
      "value": 325,
      "label": "Ahooga"
  },
  {
    "value": 2,
    "label": "Alex Singer"
  },
  {
    "value": 307,
    "label": "Allos bikes"
  },
  {
    "value": 3,
    "label": "Amsterdamair"
  },
  {
    "value": 4,
    "label": "Angell"
  },
  {
    "value": 5,
    "label": "Arcade"
  },
  {
    "value": 6,
    "label": "Argon 18"
  },
  {
    "value": 7,
    "label": "Arrow"
  },
  {
    "value": 8,
    "label": "Atlas Bike"
  },
  {
    "value": 9,
    "label": "Atala"
  },
  {
    "value": 10,
    "label": "Aventon"
  },
  {
    "value": 11,
    "label": "Avigo"
  },
  {
    "value": 12,
    "label": "Babboe"
  },
  {
    "value": 13,
    "label": "Bakfiets"
  },
  {
    "value": 14,
    "label": "Banshee"
  },
  {
    "value": 15,
    "label": "Basso"
  },
  {
    "value": 16,
    "label": "Batavus"
  },
  {
    "value": 17,
    "label": "Beaufort"
  },
  {
    "value": 292,
    "label": "BENNO"
  },
  {
    "value": 287,
    "label": "BERGAMONT"
  },
  {
    "value": 18,
    "label": "Bernard Hinault"
  },
  {
    "value": 19,
    "label": "Bernard Thevenet"
  },
  {
    "value": 323,
    "label": "BERRIA"
  },
  {
    "value": 20,
    "label": "Bertaud"
  },
  {
    "value": 21,
    "label": "Bertin"
  },
  {
    "value": 22,
    "label": "Bianchi"
  },
  {
    "value": 23,
    "label": "Bicicapcae"
  },
  {
    "value": 295,
    "label": "BIKE43"
  },
  {
    "value": 24,
    "label": "BH"
  },
  {
    "value": 25,
    "label": "BMC"
  },
  {
    "value": 26,
    "label": "Bottecchia"
  },
  {
    "value": 27,
    "label": "Breezer"
  },
  {
    "value": 28,
    "label": "Brompton"
  },
  {
    "value": 29,
    "label": "B\"twin"
  },
  {
    "value": 30,
    "label": "Bulls"
  },
  {
    "value": 31,
    "label": "Cadex"
  },
  {
    "value": 32,
    "label": "Caminade"
  },
  {
    "value": 33,
    "label": "Cannondale"
  },
  {
    "value": 34,
    "label": "Canyon"
  },
  {
    "value": 35,
    "label": "Carqon"
  },
  {
    "value": 36,
    "label": "Carraro"
  },
  {
    "value": 37,
    "label": "CBT Italia"
  },
  {
    "value": 38,
    "label": "Centurion"
  },
  {
    "value": 39,
    "label": "Cervelo"
  },
  {
    "value": 40,
    "label": "Champion"
  },
  {
    "value": 41,
    "label": "Chase"
  },
  {
    "value": 42,
    "label": "Chike"
  },
  {
    "value": 43,
    "label": "Chromag"
  },
  {
    "value": 324,
    "label": "CIOCC"
  },
  {
    "value": 44,
    "label": "Cinelli"
  },
  {
    "value": 45,
    "label": "Cipollini"
  },
  {
    "value": 46,
    "label": "CKT"
  },
  {
    "value": 47,
    "label": "Coboc"
  },
  {
    "value": 48,
    "label": "Colnago"
  },
  {
    "value": 49,
    "label": "Commmençal"
  },
  {
    "value": 50,
    "label": "Conway"
  },
  {
    "value": 51,
    "label": "Corratec"
  },
  {
    "value": 317,
    "label": "Cote"
  },
  {
    "value": 52,
    "label": "Cotic bikes"
  },
  {
    "value": 53,
    "label": "Cowboy"
  },
  {
    "value": 321,
    "label": "CLOOT"
  },
  {
    "value": 54,
    "label": "Creme"
  },
  {
    "value": 318,
    "label": "Crussis"
  },
  {
    "value": 55,
    "label": "Cube"
  },
  {
    "value": 56,
    "label": "Cult"
  },
  {
    "value": 57,
    "label": "CyclO2"
  },
  {
    "value": 58,
    "label": "Cyfac"
  },
  {
    "value": 59,
    "label": "Dahon"
  },
  {
    "value": 316,
    "label": "Damius"
  },
  {
    "value": 60,
    "label": "Dartmoor"
  },
  {
    "value": 61,
    "label": "De Rosa"
  },
  {
    "value": 62,
    "label": "Decathlon"
  },
  {
    "value": 63,
    "label": "Déda"
  },
  {
    "value": 64,
    "label": "Devinci"
  },
  {
    "value": 65,
    "label": "Diamant"
  },
  {
    "value": 66,
    "label": "Dolly"
  },
  {
    "value": 67,
    "label": "Douze Cycles"
  },
  {
    "value": 310,
    "label": "Duret-Geliano"
  },
  {
    "value": 332,
    "label": "E-mog"
  },
  {
    "value": 68,
    "label": "Easybike"
  },
  {
    "value": 319,
    "label": "Eco-triporteur"
  },
  {
    "value": 69,
    "label": "Eddy Merckx"
  },
  {
    "value": 70,
    "label": "Electra"
  },
  {
    "value": 300,
    "label": "ELOPS"
  },
  {
      "value": 314,
      "label": "Elwing"
  },
  {
    "value": 71,
    "label": "Engine Lab"
  },
  {
    "value": 72,
    "label": "Eovolt"
  },
  {
    "value": 73,
    "label": "EXS"
  },
  {
    "value": 74,
    "label": "Excelsior"
  },
  {
    "value": 75,
    "label": "Faggin"
  },
  {
    "value": 76,
    "label": "Fahrradmanufaktur"
  },
  {
    "value": 77,
    "label": "Fantic"
  },
  {
    "value": 78,
    "label": "Felt"
  },
  {
    "value": 305,
    "label": "Ferrus"
  },
  {
    "value": 79,
    "label": "Feu Vert"
  },
  {
    "value": 320,
    "label": "FISCHER"
  },
  {
    "value": 309,
    "label": "Fisher"
  },
  {
    "value": 80,
    "label": "Fixie Inc"
  },
  {
    "value": 81,
    "label": "FKC"
  },
  {
    "value": 82,
    "label": "Flyer"
  },
  {
    "value": 288,
    "label": "FLYING-CAT"
  },
  {
    "value": 83,
    "label": "Focus"
  },
  {
    "value": 84,
    "label": "Foes"
  },
  {
    "value": 85,
    "label": "Frog bikes"
  },
  {
    "value": 86,
    "label": "Fuji"
  },
  {
    "value": 87,
    "label": "Gazelle"
  },
  {
    "value": 89,
    "label": "Genesis"
  },
  {
    "value": 91,
    "label": "Ghost"
  },
  {
    "value": 93,
    "label": "Giant Stores"
  },
  {
    "value": 95,
    "label": "Girs"
  },
  {
    "value": 97,
    "label": "Gitane"
  },
  {
    "value": 99,
    "label": "Go Sport"
  },
  {
    "value": 101,
    "label": "Gocycle"
  },
  {
    "value": 103,
    "label": "Granville"
  },
  {
    "value": 105,
    "label": "Greyp"
  },
  {
    "value": 107,
    "label": "GT Bicycle"
  },
  {
    "value": 326,
    "label": "Hagen"
  },
  {
    "value": 108,
    "label": "Haibike"
  },
  {
    "value": 109,
    "label": "Haro"
  },
  {
    "value": 110,
    "label": "Hercules"
  },
  {
    "value": 331,
    "label": "HONBIKE"
  },
  {
    "value": 111,
    "label": "Hope"
  },
  {
    "value": 112,
    "label": "Husqvarna Bicycles"
  },
  {
    "value": 113,
    "label": "Ibis"
  },
  {
    "value": 114,
    "label": "Inspyre Bicycles"
  },
  {
    "value": 115,
    "label": "Intense"
  },
  {
    "value": 116,
    "label": "Iron Horse"
  },
  {
    "value": 117,
    "label": "Iweech"
  },
  {
    "value": 118,
    "label": "Jacques Anquetil"
  },
  {
    "value": 119,
    "label": "Juliana"
  },
  {
    "value": 120,
    "label": "Jumpertrek"
  },
  {
    "value": 121,
    "label": "Kalkhoff"
  },
  {
    "value": 122,
    "label": "Kellys"
  },
  {
    "value": 123,
    "label": "Kessels"
  },
  {
    "value": 124,
    "label": "Kestrel"
  },
  {
    "value": 125,
    "label": "Kettler"
  },
  {
    "value": 126,
    "label": "KHE"
  },
  {
    "value": 127,
    "label": "KHS"
  },
  {
    "value": 128,
    "label": "Kiffy"
  },
  {
    "value": 129,
    "label": "Kink BMX"
  },
  {
    "value": 333,
    "label": "Kino Bikes"
  },
  {
    "value": 130,
    "label": "Knolly"
  },
  {
    "value": 131,
    "label": "Koga"
  },
  {
    "value": 132,
    "label": "Kona"
  },
  {
    "value": 133,
    "label": "Kross"
  },
  {
    "value": 134,
    "label": "KS Cycling"
  },
  {
    "value": 135,
    "label": "KTM"
  },
  {
    "value": 136,
    "label": "Kuota"
  },
  {
    "value": 137,
    "label": "Kuwahara"
  },
  {
    "value": 329,
    "label": "Larrun"
  },
  {
    "value": 138,
    "label": "Lapierre"
  },
  {
    "value": 139,
    "label": "Lejeune"
  },
  {
    "value": 140,
    "label": "Litespeed"
  },
  {
    "value": 141,
    "label": "Liteville"
  },
  {
    "value": 297,
    "label": "LIV"
  },
  {
    "value": 142,
    "label": "Logo"
  },
  {
    "value": 289,
    "label": "LOMBARDO"
  },
  {
    "value": 143,
    "label": "Look"
  },
  {
    "value": 144,
    "label": "Lutetia"
  },
  {
    "value": 145,
    "label": "Maabikes"
  },
  {
    "value": 146,
    "label": "Mad"
  },
  {
    "value": 147,
    "label": "Marin"
  },
  {
    "value": 148,
    "label": "Massi"
  },
  {
    "value": 149,
    "label": "Matra"
  },
  {
    "value": 150,
    "label": "MBK"
  },
  {
    "value": 290,
    "label": "MBM"
  },
  {
    "value": 151,
    "label": "Mecer"
  },
  {
    "value": 294,
    "label": "MEGAMO"
  },
  {
    "value": 152,
    "label": "Mercier"
  },
  {
    "value": 312,
    "label": "Merida Bikes"
  },
  {
    "value": 153,
    "label": "Merlin"
  },
  {
    "value": 154,
    "label": "Merida"
  },
  {
    "value": 155,
    "label": "Meybo"
  },
  {
    "value": 156,
    "label": "Micmo"
  },
  {
    "value": 157,
    "label": "Moma"
  },
  {
    "value": 158,
    "label": "Mondraker"
  },
  {
    "value": 159,
    "label": "Mongoose"
  },
  {
    "value": 160,
    "label": "Montana"
  },
  {
    "value": 161,
    "label": "Monty"
  },
  {
    "value": 162,
    "label": "Motobécane"
  },
  {
    "value": 163,
    "label": "Moustache"
  },
  {
    "value": 164,
    "label": "Movea"
  },
  {
    "value": 165,
    "label": "MSC"
  },
  {
    "value": 166,
    "label": "Muddy Fox"
  },
  {
    "value": 167,
    "label": "Nakamura"
  },
  {
    "value": 301,
    "label": "NEATT"
  },
  {
    "value": 168,
    "label": "Neomouv"
  },
  {
    "value": 169,
    "label": "Nicolaï"
  },
  {
    "value": 170,
    "label": "Niner"
  },
  {
    "value": 171,
    "label": "Norco"
  },
  {
    "value": 172,
    "label": "Nox"
  },
  {
    "value": 173,
    "label": "NS bikes"
  },
  {
    "value": 174,
    "label": "Nukeproof"
  },
  {
    "value": 175,
    "label": "Olmo"
  },
  {
    "value": 176,
    "label": "On One"
  },
  {
    "value": 177,
    "label": "Optim\"alp"
  },
  {
    "value": 178,
    "label": "Orbea"
  },
  {
    "value": 179,
    "label": "Orbita"
  },
  {
    "value": 180,
    "label": "Orange"
  },
  {
    "value": 181,
    "label": "Origine"
  },
  {
    "value": 182,
    "label": "Ortler"
  },
  {
    "value": 183,
    "label": "O2feel"
  },
  {
    "value": 184,
    "label": "Panther"
  },
  {
    "value": 291,
    "label": "PEGASUS"
  },
  {
    "value": 185,
    "label": "Peugeot"
  },
  {
    "value": 328,
    "label": "PIETRO BIKE"
  },
  {
    "value": 186,
    "label": "Pinarello"
  },
  {
    "value": 187,
    "label": "Pivot Cycles"
  },
  {
    "value": 188,
    "label": "Polygon"
  },
  {
    "value": 189,
    "label": "Position One"
  },
  {
    "value": 190,
    "label": "Production privée"
  },
  {
    "value": 313,
    "label": "Propain"
  },
  {
    "value": 191,
    "label": "Puch"
  },
  {
    "value": 192,
    "label": "Quantum"
  },
  {
    "value": 193,
    "label": "Q bikes"
  },
  {
    "value": 194,
    "label": "Rabeneick"
  },
  {
    "value": 195,
    "label": "Rad Bike"
  },
  {
    "value": 196,
    "label": "Radio Bikes"
  },
  {
    "value": 197,
    "label": "Radon"
  },
  {
    "value": 198,
    "label": "Raleigh"
  },
  {
    "value": 199,
    "label": "Raymon"
  },
  {
    "value": 200,
    "label": "Rayvolt bikes"
  },
  {
    "value": 201,
    "label": "Redline"
  },
  {
    "value": 202,
    "label": "Riese & Müller"
  },
  {
    "value": 203,
    "label": "Ridley"
  },
  {
    "value": 204,
    "label": "Ritchey"
  },
  {
    "value": 299,
    "label": "RIVERSIDE"
  },
  {
    "value": 205,
    "label": "Rockrider"
  },
  {
    "value": 206,
    "label": "Rocky Mountain"
  },
  {
    "value": 296,
    "label": "ROMET"
  },
  {
    "value": 207,
    "label": "Rondo"
  },
  {
    "value": 208,
    "label": "Rose"
  },
  {
    "value": 209,
    "label": "Rossignol"
  },
  {
    "value": 210,
    "label": "Rotwild"
  },
  {
    "value": 211,
    "label": "Ruff Cycles"
  },
  {
    "value": 212,
    "label": "Samebike"
  },
  {
    "value": 213,
    "label": "Santa Cruz"
  },
  {
    "value": 302,
    "label": "SCAMP"
  },
  {
    "value": 214,
    "label": "Schwinn"
  },
  {
    "value": 215,
    "label": "Scott"
  },
  {
    "value": 216,
    "label": "Scrapper"
  },
  {
    "value": 306,
    "label": "Sensa"
  },
  {
    "value": 217,
    "label": "Serious"
  },
  {
    "value": 218,
    "label": "SE Racing"
  },
  {
    "value": 219,
    "label": "Seven"
  },
  {
    "value": 293,
    "label": "SHENGMILO"
  },
  {
    "value": 220,
    "label": "Simplon"
  },
  {
    "value": 221,
    "label": "Sinus"
  },
  {
    "value": 222,
    "label": "Sirius"
  },
  {
    "value": 303,
    "label": "SMOBY"
  },
  {
    "value": 223,
    "label": "Sobre"
  },
  {
    "value": 224,
    "label": "Solex"
  },
  {
    "value": 225,
    "label": "Sparta"
  },
  {
    "value": 226,
    "label": "Specialized"
  },
  {
    "value": 227,
    "label": "Spego"
  },
  {
    "value": 228,
    "label": "Starway"
  },
  {
    "value": 322,
    "label": "Stealth Electric Bikes"
  },
  {
    "value": 304,
    "label": "STILUS"
  },
  {
    "value": 229,
    "label": "Storck"
  },
  {
    "value": 230,
    "label": "Strida"
  },
  {
    "value": 231,
    "label": "Stromer"
  },
  {
    "value": 232,
    "label": "Subrosa"
  },
  {
    "value": 233,
    "label": "Sunday Bikes"
  },
  {
    "value": 234,
    "label": "Sunn"
  },
  {
    "value": 235,
    "label": "Swift"
  },
  {
    "value": 236,
    "label": "Swype"
  },
  {
    "value": 327,
    "label": "Taboo"
  },
  {
    "value": 237,
    "label": "Talbot"
  },
  {
    "value": 238,
    "label": "T-bird"
  },
  {
    "value": 330,
    "label": "TENWAYS"
  },
  {
    "value": 239,
    "label": "Tern"
  },
  {
    "value": 240,
    "label": "Thirty One"
  },
  {
    "value": 241,
    "label": "Tilgreen"
  },
  {
    "value": 242,
    "label": "Time"
  },
  {
    "value": 243,
    "label": "Titici"
  },
  {
    "value": 244,
    "label": "Topbike"
  },
  {
    "value": 245,
    "label": "Top Gun"
  },
  {
    "value": 246,
    "label": "Torker"
  },
  {
    "value": 247,
    "label": "Torpado"
  },
  {
    "value": 248,
    "label": "Transition"
  },
  {
    "value": 249,
    "label": "Trek"
  },
  {
    "value": 298,
    "label": "TRIBAN"
  },
  {
    "value": 250,
    "label": "Turner"
  },
  {
    "value": 334,
    "label": "ULTIMA Mobility"
  },
  {
    "value": 252,
    "label": "Union"
  },
  {
    "value": 253,
    "label": "Univega"
  },
  {
    "value": 254,
    "label": "Urban Arrow"
  },
  {
    "value": 255,
    "label": "Vaast"
  },
  {
    "value": 256,
    "label": "Van Dijck"
  },
  {
    "value": 257,
    "label": "Van Moof"
  },
  {
    "value": 258,
    "label": "Van Rysel"
  },
  {
    "value": 259,
    "label": "Vario"
  },
  {
    "value": 260,
    "label": "Velair"
  },
  {
    "value": 261,
    "label": "Velobecane"
  },
  {
    "value": 308,
    "label": "Velo de ville"
  },
  {
    "value": 262,
    "label": "Vendetta"
  },
  {
    "value": 263,
    "label": "Ventana"
  },
  {
    "value": 264,
    "label": "Venilu"
  },
  {
    "value": 265,
    "label": "Vermont"
  },
  {
    "value": 266,
    "label": "Via Veneto"
  },
  {
    "value": 267,
    "label": "Victoire"
  },
  {
    "value": 268,
    "label": "Vitus"
  },
  {
    "value": 269,
    "label": "Voodoo"
  },
  {
    "value": 270,
    "label": "Votec"
  },
  {
    "value": 271,
    "label": "VUF"
  },
  {
    "value": 272,
    "label": "Wayscral"
  },
  {
    "value": 273,
    "label": "Wanderer"
  },
  {
    "value": 274,
    "label": "Whe The People"
  },
  {
    "value": 275,
    "label": "Wheeler"
  },
  {
    "value": 276,
    "label": "Whistle"
  },
  {
    "value": 277,
    "label": "White bikes"
  },
  {
    "value": 278,
    "label": "Whyte"
  },
  {
    "value": 279,
    "label": "Wilier Triestina"
  },
  {
      "value": 280,
      "label": "Winora"
  },
  {
      "value": 311,
      "label": "Woodsun"
  },
  {
    "value": 281,
    "label": "Xiaomi"
  },
  {
    "value": 335,
    "label": "Yamaha"
  },
  {
    "value": 282,
    "label": "Yeti"
  },
  {
    "value": 283,
    "label": "YT Industries"
  },
  {
    "value": 284,
    "label": "Yokler"
  },
  {
    "value": 285,
    "label": "Yuba"
  },
  {
    "value": 286,
    "label": "Zumbi"
  }
]

export const getBrandLabelFromValue = (bikeValue: number) =>
  bikeBrands.find((type) => type.value === bikeValue)?.label

export const getBrandValueFromLabel = (bikelabel: string) => 
  bikeBrands.find((type) => type.label === bikelabel)?.value